import { TLShape } from '@tldraw/tldraw'
import { VisualElement } from 'api/clients/VisualElementClient'
import { DesignChannel } from 'components/NewFileModal/Types'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { MaskShape } from 'components/VisualStudioPlayground/Shapes/MaskShape/Types'

export const hasPlaceholderImage = (template?: VisualElement) => {
  if (!template) return false

  const shapes = Object.values(template.content.snapshot.store).filter(
    (shape): shape is TLShape => shape.typeName === 'shape',
  )

  const shape = shapes.find((shape) => {
    if (shape.type === 'image' || shape.type === 'mask') {
      const {
        props: { isReplaceable, wasReplaced },
      } = shape as ImageShape | MaskShape
      return isReplaceable && !wasReplaced
    }

    return false
  })

  return !!shape
}

const SIMPLIFIED_WIZARD_CHANNELS = [
  DesignChannel.InstagramPost,
  DesignChannel.InstagramStory,
  DesignChannel.InstagramReel,
  DesignChannel.FacebookPost,
  DesignChannel.TwitterPost,
  DesignChannel.LinkedInPost,
  DesignChannel.Post,
]

export const isSimplifiedWizard = (channel: DesignChannel) => {
  return SIMPLIFIED_WIZARD_CHANNELS.includes(channel)
}
